(function () {
  'use strict';
  var root = document.querySelector('[data-contact]');
  var form = root && root.querySelector('[data-contact-form]');
  if (!form) return;
  var renderedAt = Date.now();
  var stamp = form.querySelector('[data-contact-rendered]');
  if (stamp) stamp.value = String(renderedAt);
  var err = form.querySelector('[data-contact-error]');
  var done = form.querySelector('[data-contact-done]');
  var btn = form.querySelector('[data-contact-submit]');
  var busy = false, fallback = false;
  function fail(msg) { if (err) { err.textContent = msg; err.hidden = false; } }
  function val(n) { var el = form.querySelector('[name="contact[' + n + ']"]'); return el ? el.value : ''; }
  form.addEventListener('submit', function (e) {
    if (fallback) return;
    e.preventDefault();
    if (busy) return;
    if (err) err.hidden = true;
    var email = val('email').trim(), body = val('body').trim(), name = val('name').trim();
    if (!name) { fail('Enter your name.'); return; }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { fail('Enter a valid email address.'); return; }
    if (!body) { fail('Write a message.'); return; }
    busy = true; if (btn) { btn.disabled = true; btn.textContent = 'Sending'; }
    fetch((document.documentElement.getAttribute('data-api') || 'https://front.4147r3yu.com').replace(/\/+$/, '') + '/api/messages', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name, email: email, category: val('category') || 'general', body: body, website: val('website'), rendered_at: renderedAt })
    }).then(function (r) { return r.ok ? r.json().catch(function () { return { success: true }; }) : Promise.reject(new Error('http ' + r.status)); })
      .then(function (d) {
        if (d && d.success !== false) {
          form.querySelectorAll('input, select, textarea, button').forEach(function (el) { el.disabled = true; });
          if (btn) btn.textContent = 'Sent';
          if (done) done.hidden = false;
          if (typeof window.gtag === 'function') window.gtag('event', 'contact_form_sent', { category: val('category') || 'general' });
          return;
        }
        throw new Error('api');
      })
      .catch(function () {
        fallback = true; busy = false;
        if (btn) { btn.disabled = false; }
        form.submit();
      });
  });
})();
